import * as React from 'react'
import get from 'lodash/get'
import moment from 'moment-mini'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { unblockUser, unfollowUser } from '../../../store/member/memberSlice'
import { BlacklistItem, FolloweeItem, FollowerItem } from '../../../store/member/memberTypings'
import { genders } from '../../../constants'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import { useHistory } from 'react-router-dom'
import AvatarLink from '../../profile/avatarLink/avatarLink'

interface Props {
    follower?: FollowerItem | null
    followee?: FolloweeItem | null
    favorite?: boolean
    blacklistItem?: BlacklistItem | null
}

const TableItem: React.FunctionComponent<Props> = ({
    blacklistItem = null,
    follower = null,
    followee = null,
    favorite = false
}: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()

    const unblock = () => {
        dispatch(unblockUser({ blacklisted_user_id: Number(blacklistItem.blacklisted_user_id) }))
    }

    const unfollow = () => {
        dispatch(unfollowUser({ id: Number(followee.followee_id) }))
    }

    // @ts-ignore
    const { nick, avatar_url } =
        get(blacklistItem, 'banned_user') || get(followee, 'followee') || get(follower, 'follower')

    return (
        <div
            className={follower ? 'tableItem follower' : 'tableItem'}
            onClick={() => {
                history.push(createLocalizedPath(paths.profile.toPath({ nick: nick })))
            }}
        >
            <div className="main">
                <AvatarLink img={avatar_url} nick={nick} />
                <div className="nick">{nick}</div>
            </div>
            {blacklistItem && (
                <>
                    <div className="unblock" onClick={unblock}>
                        {t('unblock')}
                    </div>
                    <div className="blockDate">
                        <div className="blockTitle">{t('Adding date')}</div>
                        {moment(blacklistItem.date * 1000).format(t('time format'))}
                    </div>
                    <div className="blockExpiry">
                        <div className="blockTitle">{t('Expiration date')}</div>
                        {blacklistItem.expiration_date
                            ? moment(blacklistItem.expiration_date * 1000).format(t('time format'))
                            : t('Permanent')}
                    </div>
                    {blacklistItem.reason && (
                        <div className="blockReason">
                            <div className="blockTitle">{t('Reason')}</div>
                            {blacklistItem.reason}
                        </div>
                    )}
                </>
            )}
            {follower && (
                <>
                    <div className="blockDate">
                        <div className="blockTitle">{t('Sex')}</div>
                        {t(genders.find((x) => x.value === follower.follower.gender).label)}
                    </div>
                    <div className="blockExpiry">
                        <div className="blockTitle">{t('Age')}</div>
                        {follower.follower.age}
                    </div>
                    <div className="blockReason">
                        <div className="blockTitle">{t('Location')}</div>
                        {follower.follower.country && (
                            <span className="location">
                                {follower.follower.country}
                                {follower.follower.region && `, ${follower.follower.region}`}
                            </span>
                        )}
                    </div>
                </>
            )}
            {followee && (
                <>
                    <div className="unblock" onClick={unfollow}>
                        {favorite ? t('Delete') : t('unfollow')}
                    </div>
                    <div className="blockDate">
                        <div className="blockTitle">{t('Sex')}</div>
                        {t(genders.find((x) => x.value === followee.followee.gender).label)}
                    </div>
                    <div className="blockExpiry">
                        <div className="blockTitle">{t('Age')}</div>
                        {followee.followee.age}
                    </div>
                    <div className="blockReason">
                        <div className="blockTitle">{t('Location')}</div>
                        {followee.followee.country && (
                            <span className="location">
                                {followee.followee.country}
                                {followee.followee.region && `, ${followee.followee.region}`}
                            </span>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}

export default TableItem
